import { colorOptions } from "../../constants";

export const ColourSelector = ({
  product,
  selectedColour,
  setSelectedColour,
}) => {
  if (!product.colors || product.colors.length <= 1) return null;

  return (
    <div
      className="shopItem-color-selector"
      style={{ display: "flex", flexDirection: "column", gap: "0rem" }}
    >
      <p
        style={{
          margin: "0px 0 6px 0px",
          fontWeight: 500,
          color: "#333",
        }}
      >
        Colour: {selectedColour}
      </p>

      <div
        style={{
          display: "flex",
          gap: "0.85rem",
          alignItems: "center",
          flexWrap: "wrap",
          marginLeft: "3px",
        }}
      >
        {product.colors.map((color) => {
          const hex = colorOptions[color] || color;
          const selected = color === selectedColour;
          const normalizedHex = String(hex).toLowerCase();
          const isLight = ["#fff", "#ffffff", "white"].includes(normalizedHex);

          return (
            <button
              key={color}
              type="button"
              className="shopItem-color-btn"
              onClick={() => setSelectedColour(color)}
              aria-label={`Select colour ${color}`}
              aria-pressed={selected}
              title={color}
              style={{
                border: selected ? "2px solid #c62828" : "2px solid #e0e0e0",
                background: selected ? "#fff1f1" : "#fff",
                padding: 0,
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: selected
                  ? "0 2px 8px rgba(211, 47, 47, 0.12)"
                  : "none",
                transform: selected ? "scale(1.03)" : "scale(1)",
                transition:
                  "border-color 0.2s, transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s, background 0.2s",
                position: "relative",
              }}
            >
              <span
                style={{
                  display: "block",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: hex,
                  border: isLight ? "1px solid #d9d9d9" : "none",
                }}
              />

              {selected && (
                <span
                  style={{
                    position: "absolute",
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    background: isLight ? "#c62828" : "#fff",
                    boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
